import { render, staticRenderFns } from "./ChannelItemsSelect.vue?vue&type=template&id=e1a74248&scoped=true&"
import script from "./ChannelItemsSelect.vue?vue&type=script&lang=js&"
export * from "./ChannelItemsSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1a74248",
  null
  
)

export default component.exports